// utils
import React from "react";


//page sections
import ContactForm from "../contact/components/contact-form/contact-form";
import ContactTeam from "../contact/components/contact-team/contact-team";


/**
 * CONTACT_US page
 * Handles whole CONTACT_US page with form
 * @returns HTML element for CONTACT_US page with <form>
 */
export default function Index() {
    
    return (
        <>
            <div className="fade-in-750">
                <ContactForm navbarCompensation={true}></ContactForm>
                <ContactTeam navbarCompensation={false}></ContactTeam>
            </div>

        </>

    );
}
